angular.module('olivioConfiguratorApp')
  .controller('ChargingCtrl', function ($rootScope, $scope, Model, Data, DesignCtrlService, OLIVIOMainFactory, StepService, ColorSelectService, AdvancedLoginService, Storage, $window, $location) {

    $scope.OLIVIO = OLIVIO;
    $scope.data = Data;
    $scope.model = Model.model;
    $scope.cmodel = OLIVIO.cmodel;
    $scope.service = DesignCtrlService;

    //Model.model.charging.done = true; // will be set by question

    StepService.updateEnabled();


    // xTxOxDxOx WATCH
    // skalierung ist immer dieselbe, immer an der Unterkante eines 3960 svg-px großen Bilder anordnen (mit center-bottom)
    //switch(Model.model.product.id) {
    //  case OLIVIO.PRODUCT_CANDELABRA:
    //    $scope.mast = SVG2JS.getPart(SVG2JS.OCM1LUM3000Array[0]); // WONT entsprechend Größe OCM1LUM3000Array[0] oder OCM1LUM4500Array[0]
    //  case OLIVIO.PRODUCT_FLORACION:
    //    $scope.mast = SVG2JS.getPart(SVG2JS.OFMastArray[0]); // WONT richtiger Index entsprechned Größe, index 0 ist 12Meter hoch
    //  default:
    //    $scope.mast = SVG2JS.getPart(SVG2JS.OSMastArray[0]); // WONT richtiger Index entsprechned Größe, index 0 ist 12Meter hoch
    //}
    //console.log('mast', Model.model.product.id, $scope.mast);

    $scope.mast = SVG2JS.getPart(SVG2JS.OCM1LUM3000Array[0]);
    $scope.mast = "url('" +$scope.mast + "')";


    var lastCharging1Arrangment = Model.model.charging.arrangement;
    var lastCharging2Arrangment = Model.model.charging.arrangement;

    var updateChargings = function() {
      // WONT aktuell sichtbaren slidejs verschieben und sein lastChargingXArrangment setzen. das ist notwendig sobald das Arrangement per DesignInfo geändert werden kann. erstmal nicht

      var arrangement = Data.getChargingArrangementOption(Model.model.charging.count, Model.model.charging.arrangement);
      $scope.charging090 = arrangement[0];
      $scope.charging180 = arrangement[1];
      $scope.charging270 = arrangement[2];
      //console.log('updateChargings', Model.model.charging.count, Model.model.charging.arrangement, arrangement, $scope.charging090, $scope.charging180, $scope.charging270);
    };

    $scope.$watch('model.charging.count', function() {
      //  arrangement entsprechend lastChargingXArrangment setzen!
      if($scope.model.charging.count === 1 && Model.model.charging.arrangement !== lastCharging1Arrangment ) {
        Model.model.charging.arrangement = lastCharging1Arrangment;
      }
      if($scope.model.charging.count === 2 && Model.model.charging.arrangement !== lastCharging2Arrangment ) {
        Model.model.charging.arrangement = lastCharging2Arrangment;
      }
      updateChargings();
    });
    $scope.$watch('model.charging.arrangement', updateChargings);

    updateChargings();

    $scope.charging1SelectorSetup = {
      start: $scope.model.charging.arrangement + 1,
      width: 175, // MUST match $charging_topSize in charging.scss
      height: 175, // MUST match $charging_topSize in charging.scss
      navigation: false,
      blockcallback: false,
      callback: {
        loaded: function (number) {
        },
        start: function (number) {
        },
        complete: function (number) {
          $scope.selectArrangement1(number - 1);
        }
      },
      goto: function (number) {
        // will be replaced by real goto during execution of .directive('sliderjs')
      }
    };

    $scope.charging2SelectorSetup = {
      start: $scope.model.charging.arrangement + 1,
      width: 175, // MUST match $charging_topSize in charging.scss
      height: 175, // MUST match $charging_topSize in charging.scss
      navigation: false,
      blockcallback: false,
      callback: {
        loaded: function (number) {
        },
        start: function (number) {
        },
        complete: function (number) {
          $scope.selectArrangement2(number - 1);
        }
      },
      goto: function (number) {
        // will be replaced by real goto during execution of .directive('sliderjs')
      }
    };

    $scope.selectArrangement1 = function(arr) {
      console.log('selectArrangement1 ',arr, Model.model.charging.count === 1);
      lastCharging1Arrangment = arr;
      if(Model.model.charging.count === 1) {
        $rootScope.$safeApply($scope, function() {
          $scope.model.charging.arrangement = arr;
        });
      }
    };

    $scope.selectArrangement2 = function(arr) {
      console.log('selectArrangement2 ',arr, Model.model.charging.count === 2);
      lastCharging2Arrangment = arr;
      if(Model.model.charging.count === 2) {
        $rootScope.$safeApply($scope, function() {
          $scope.model.charging.arrangement = arr;
        });
      }
    };

    $scope.setChargings = function(n) {
      console.log('setChargings ', n, n===parseInt(n));
      if(n!== Model.model.charging.count && n>= 0 && n<4) {
        if(n === 1 && Model.model.charging.arrangement !== lastCharging1Arrangment ) {
          // geht nicht, weil sliderjs beim goto abstürzt :(
          //lastCharging1Arrangment = Model.model.charging.arrangement;
          //$scope.charging1SelectorSetup.goto(Model.model.charging.arrangement + 1);

          Model.model.charging.arrangement = lastCharging1Arrangment;
        }
        if(n === 2 && Model.model.charging.arrangement !== lastCharging2Arrangment ) {
          // geht nicht, weil sliderjs beim goto abstürzt :(
          //lastCharging2Arrangment = Model.model.charging.arrangement;
          //$scope.charging2SelectorSetup.goto(Model.model.charging.arrangement + 1);

          Model.model.charging.arrangement = lastCharging2Arrangment;
        }

        Model.model.charging.count = n;
      }
    };

    $scope.yesPlease = function() {
      Model.model.charging.count=1;
      Model.model.charging.done = true;
      StepService.updateEnabled();
    };

    $scope.noThanks = function() {
      $scope.model.charging.done = true;
      StepService.nextStep();
    }

  });
